import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Client } from 'models/ClientModel';
import AsyncSelect from "react-select/async";

const FamilyList: React.FC = () => {
  const width = { id: 15, client: 35, dob: 20, age: 20 }
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab("family"));
  const [formData, setFormData] = useState<Client>({});
  const [selectedClientData, setSelectedClientData] = useState<Client>({});
  const [clientData, setClientData] = useState<Client[]>([]); 
    
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
     API.Data.GetByKeyId<Client>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        callClientList(data.client_family_id);
      }})
      setLoading(false);
  }, []);

  const callClientList = async (familyId: number | undefined) => {
      if (!familyId) return;  
        const url = API.Build.FormApiEndpint(Code.Form.Name.CLIENT, 0, Name.Client.Id, Code.Option.Sort.ASC, {
        fields: Utility.Join.Fields([
          Name.Client.Id, 
          Name.Client.Number, 
          Name.Client.FullName, 
          Name.Client.Dob, 
        ]),
        [Name.Client.FamilyId]: familyId,
      });
      await API.Data.List<Client>(url, setClientData, setError, setLoading);
   };

   const joinIntoFamily = async () => {
    const clientId = selectedClientData.client_id
      if (clientId) {
        const updatedData: Client = {
          client_id: clientId,
          client_family_id: formData.client_family_id
        };
        const response = await API.Data.Save(formName, clientId, updatedData, setMessage)
        if(response){
          Utility.Message.Info(["Selected client has been joind this family"],setMessage);
          onRefresh();
        }
      }
      else 
        Utility.Message.Warning(["Please select a client to join into family."],setMessage);
   };

   const detachFromFamily = async () => {
      const clientId = selectedClientData.client_id
      if (clientId) {
        const updatedData: Client = {
          client_id: clientId,
          client_family_id: clientId
        };
        const response = await API.Data.Save(formName, clientId, updatedData, setMessage)
        if(response){
          Utility.Message.Info(["Selected client has been detach from this family"],setMessage);
          onRefresh();
        }
      }
      else
        Utility.Message.Warning(["Please select a client to detach from family."],setMessage);
   };

   const onRefresh = () => {
    const familyId = formData.client_family_id
      if(familyId){
        callClientList(familyId);
      }
    };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef}>
          <Button.Top formName='Family' />
          <Control.Tab.Header titles={["Family"]} activeTab={activeTab} formName={"family"} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.ClientId, width.id],
                    [Title.Client, width.client],
                    [Title.DOB, width.dob],
                    [Title.Age, width.age],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {clientData.map((client, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <a className={`flcol list-col2 edit`} onClick={()=>Utility.Handle.openClientOnPanel(`${client.client_first_name ||''} ${client.client_middle_name ||''} ${client.client_last_name ||''} #${client.client_number ||''}`, client.client_id!.toString())}  title={"Open this record"}>&nbsp;</a>
                        <Control.Grid.Items values={[
                          [`#${client.client_number}`, width.id],
                          [Utility.Get.FullName(client,Code.Form.Name.CLIENT), width.client],
                          [Utility.Format.DateOnly(client.client_dob), width.dob],
                          [Utility.Format.Age(client.client_dob), width.age],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>

               <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setSelectedClientData)} value={Utility.Value.Async(selectedClientData.client_id,selectedClientData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              <Control.Row className='tbleft'>
                <Button.Action title="Join" info={'Click to join this client in above family'} onClick={joinIntoFamily} />
                <Button.Action title="Detach" info={'Click to Detach this client from above family'} onClick={detachFromFamily} className='bcolor3' />
              </Control.Row>

            </Control.Tab.Content>
          </Control.Form.Data>
        </form>
      )}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default FamilyList;